module.exports = __webpack_public_path__ + "img/solution9.18eb3b14.png";